module.exports = __webpack_public_path__ + "images/ba39c0f.jpg";